import { render } from "./VehicleBrandForm.vue?vue&type=template&id=1e89f3f4"
import script from "./VehicleBrandForm.vue?vue&type=script&lang=js"
export * from "./VehicleBrandForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__